/*
 * This file is part of glowingblue/related.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { KeyValueGambit } from 'flarum/common/query/IGambit';

/**
 * `related:<id>` — discussions sharing tags with the given discussion, ranked
 * by how many they share. Backed by the related_to filter.
 */
export default class RelatedGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('glowingblue-related.lib.gambits.discussions.related.key', {}, true);
  }
  hint() {
    return app.translator.trans('glowingblue-related.lib.gambits.discussions.related.hint', {}, true);
  }
  filterKey() {
    return 'related_to';
  }
}
flarum.reg.add('glowingblue-related', 'forum/query/RelatedGambit', RelatedGambit);